export { PremiumFaq } from "../conversion-sections"
export type { PremiumFaqItem, PremiumFaqProps } from "../conversion-sections"